import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from "./auth-service-tools630.js";
import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import { useCallback } from "react";
import { useLiveRef } from "./auth-service-tools643.js";
import { useButton } from "./auth-service-tools653.js";
import { D as DISCLOSURE_KEYS } from "./auth-service-tools681.js";
var useDisclosure = createHook({
  name: "Disclosure",
  compose: useButton,
  keys: DISCLOSURE_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlOnClick = _ref.onClick,
        ariaControls = _ref["aria-controls"],
        htmlProps = _objectWithoutPropertiesLoose(_ref, ["onClick", "aria-controls"]);

    var onClickRef = useLiveRef(htmlOnClick);
    var controls = ariaControls ? ariaControls + " " + options.baseId : options.baseId;
    var onClick = useCallback(function (event) {
      var _onClickRef$current, _options$toggle;

      (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 ? void 0 : _onClickRef$current.call(onClickRef, event);
      if (event.defaultPrevented) return;
      (_options$toggle = options.toggle) === null || _options$toggle === void 0 ? void 0 : _options$toggle.call(options);
    }, [options.toggle]);
    return _objectSpread2({
      "aria-expanded": !!options.visible,
      "aria-controls": controls,
      onClick
    }, htmlProps);
  }
});
createComponent({
  as: "button",
  memo: true,
  useHook: useDisclosure
});
export { useDisclosure };